import * as Factory from 'factory.ts'
import faker from 'faker'

import { SecondaryCategoryApiModelStub } from './SecondaryCategoryApiModel.stub'
import { type ApproverApiModel } from '../ApproverApiModel'

export const ApproverApiModelStub = Factory.Sync.makeFactory<ApproverApiModel>({
  id: Factory.each(() => faker.random.number()),
  firstName: Factory.each(() => faker.name.firstName()),
  lastName: Factory.each(() => faker.name.lastName()),
  email: Factory.each(() => faker.internet.email()),
  is_active: true,
  department: SecondaryCategoryApiModelStub.build(),
  address: faker.address.streetAddress(),
  approval_delegatee: null,
  created_at: faker.date.past(10).toISOString(),
  is_sso_enabled: false,
  last_changed_by: null,
  mobile: false,
  notifications: false,
  phone: faker.phone.phoneNumber(),
  position: '',
  profile_image: Factory.each(() => faker.image.avatar()),
  slack_user_id: '',
  updated_at: faker.date.past(10).toISOString(),
  user: Factory.each(() => faker.random.number()),
})
